import React from 'react';

export async function parseAndThrowServerError(response) {
  const responseBody = await response.json();
  if (responseBody.error) {
    throw new Error(responseBody.error);
  } else {
    console.error(response);
    throw new Error(`Request failed with status ${response.status}`);
  }
}

function ErrorMessage({ message }) {
  if (!message) {
    return null;
  }

  let displayMessage = message.replace("Error:", "").trim();

  if (displayMessage === "Failed to fetch") {
    displayMessage = "Unable to connect to the server. Please check your internet connection or try again later.";
  }

  return (
    <div
      className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mt-4 text-center"
      role="alert"
    >
      <span className="block sm:inline">{displayMessage}</span>
    </div>
  )
}

export default ErrorMessage;
